// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".em-tile__root{border-radius:4px}.em-tile__footer{background-color:#f9f9f9}.em-tile__footer[ng-transclude=footer]:empty{display:none}", ""]);
// Exports
module.exports = exports;
